import { useLoadedFlagValue } from '@/utils/sharedHooks'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

/**
 * Whether customers can start this tax season: true when either the kickoff
 * survey or the full launch flag is on, null until both flags load.
 */
export const useIsTaxSeasonOpen = (): boolean | null => {
  const canAccessTaxSeasonKickoff = useLoadedFlagValue(
    FEATURE_FLAG_KEYS.canAccessTaxSeasonKickoffSurvey,
    false
  )
  const isFullLaunchTaxSeason = useLoadedFlagValue(
    FEATURE_FLAG_KEYS.enableFullLaunchTaxSeason,
    false
  )

  if (canAccessTaxSeasonKickoff === null || isFullLaunchTaxSeason === null) {
    return null
  }
  return canAccessTaxSeasonKickoff || isFullLaunchTaxSeason
}
